<div class="error-container">
  <div class="error-content">
    <p-card styleClass="error-card">
      <ng-template pTemplate="header">
        <div class="error-header" [ngClass]="errorData.severity">
          <i [class]="errorData.icon"></i>
          <h1>{{ errorData.title }}</h1>
          <div class="error-code" *ngIf="errorData.code">
            {{ errorData.code }}
          </div>
        </div>
      </ng-template>

      <div class="error-body">
        <div class="solution-block" *ngIf="errorData.message">
          <h3>Message:</h3>
          <p>{{ errorData.message }}</p>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-center p-mt-3 error-actions">
          <p-button type="button" label="Retour à l'accueil" icon="pi pi-home" [severity]="errorData.severity"
            (click)="goHome()"></p-button>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>
